import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { allProductUrl, getProductByProductIdUrl } from "../../utils/urls";
import AddLeadPopup from "../Leads/AddLeadPopup";
import { useSelector } from "react-redux";
import AdvisorConditionsModal from "../common/AdvisorConditionsModal";
import AddLeadModal from "../common/AddLeadModal/AddLeadModal";
const ProductDetail = () => {
  const navigate = useNavigate();
  const { productId } = useParams();
  const loggedInUser = useSelector((state) => state.auth);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAddLeadOpen, setIsAddLeadOpen] = useState(false);

  // Fetch product data using productId
  useEffect(() => {
    const fetchProductDetails = async () => {
      console.log("productId", productId);
      console.log(getProductByProductIdUrl(productId));

      if (!productId) {
        setError("Product ID not provided.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(getProductByProductIdUrl(productId), {
          params: { product_id: productId },
        });
        if (response.data.success) {
          console.log("response data", response.data.data.data);
          setProduct(response.data.data.data[0]);
        } else {
          setError("Failed to load product details.");
        }
      } catch (err) {
        setError("Failed to load product details.");
        console.error("Error fetching product details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProductDetails();
  }, [productId]);

  // Handler for "Add New Lead" button
  const handleAddNewLead = async () => {
    if (product) {
      if (
        loggedInUser?.user?.advisor_onboarding_status_id?.title === "Approved"
      ) {
        setIsAddLeadOpen(true);
      } else {
        const confirmed = await AdvisorConditionsModal.show(navigate);
        console.log("confirmed", confirmed);
      }
    }
  };

  // Show loading state
  if (loading) {
    return (
      <div className="page-container d-flex items-center p-6 text-gray-600">
        Loading...
      </div>
    );
  }

  // Show error state
  if (error) {
    return <div className="p-6 text-red-600">{error}</div>;
  }

  // Show fallback if no product data (shouldn't happen if fetch succeeds)
  if (!product) {
    return <div className="p-6 text-gray-600">Product not found.</div>;
  }

  return (
    <div className="page-container">
      {/* Header with Back and Add New Lead buttons */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-blue-600">Products</h1>
        <div className="flex gap-3">
          {/* <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-100"
          >
            Back
          </button> */}
          <button
            disabled={
              !Boolean(
                !loggedInUser?.isSkipLogin && loggedInUser?.isAuthenticated
              )
            }
            onClick={handleAddNewLead}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Add New Lead
          </button>
        </div>
      </div>

      {/* Product Details Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Promotional Image */}
        <div className="w-full">
          <img
            src={product.promotional_image_url}
            alt={`${product.product_name} promotional image`}
            className="w-full h-64 object-cover rounded-lg mx-auto"
          />
        </div>

        {/* Product Details */}
        <div className="flex flex-col gap-4">
          {/* Product Name */}
          <h2 className="text-lg font-semibold text-gray-800">
            {product.product_name}
          </h2>

          {/* Company Name */}
          <p className="text-base text-gray-600">
            Company: <span className="font-medium">{product.company_name}</span>
          </p>

          {/* Description */}
          <div className="flex flex-col gap-2">
            <h3 className="text-base font-semibold text-gray-800">
              Description :
            </h3>
            <p className="text-sm text-gray-600">{product.description}</p>
          </div>
        </div>
      </div>

      <div className="flex flex-col mt-4 gap-2">
        <h3 className="text-base font-semibold text-gray-800">
          Financial Description :
        </h3>
        <p className="text-sm text-gray-600">
          {product?.financial_description}
        </p>
      </div>

      <div className="mt-7 flex flex-col gap-2">
        <h3 className="text-base font-semibold text-gray-800">Links :</h3>
        <div className="flex flex-row gap-4">
          <div
            onClick={() => {
              window.open(product?.promotional_video_url, "_blank");
            }}
            className="flex gap-2 items-center py-2 px-3 border-[1px] border-gray-300 rounded-lg cursor-pointer max-sm:flex-col max-sm:text-center"
          >
            <VideoSvg />
            <p>Promotional video</p>
          </div>

          <div className="bg-gray-300 h-full w-px"></div>

          <div
            onClick={() => {
              window.open(product?.product_brochure_url, "_blank");
            }}
            className="flex gap-2 items-center py-2 px-3 border-[1px] border-gray-300 rounded-lg cursor-pointer max-sm:flex-col max-sm:text-center"
          >
            <PdfSvg />
            <p>Product brochure</p>
          </div>
        </div>
      </div>

      {/* Add Lead Popup */}
      {/* <AddLeadPopup
        isOpen={isAddLeadOpen}
        onClose={() => setIsAddLeadOpen(false)}
        onLeadAdded={handleLeadAdded}
        preselectedProduct={product}
      /> */}
      {isAddLeadOpen && (
        <AddLeadModal
          isOpen={isAddLeadOpen}
          onClose={() => setIsAddLeadOpen(false)}
          preselectedProduct={product}
          preSelectedCategory={{
            category_id: product?.category_category_id,
            title: product?.category_title,
            description: product?.category_description,
            logo_url: product?.category_logo_url,
            is_lead_add_without_product:
              product?.category_is_lead_add_without_product,
          }}
          preSelectedSubCategory={{
            sub_category_id: product?.sub_category_id,
            title: product?.sub_category_title,
            description: product?.sub_category_description,
            logo_url: product?.sub_category_logo_url,
            category_id: {
              category_id: product?.category_category_id,
              title: product?.category_title,
              description: product?.category_description,
              logo_url: product?.category_logo_url,
              is_lead_add_without_product:
                product?.category_is_lead_add_without_product,
            },
          }}
        />
      )}
    </div>
  );
};

export default ProductDetail;

function VideoSvg() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6C3 4.34315 4.34315 3 6 3H14C15.6569 3 17 4.34315 17 6V14C17 15.6569 15.6569 17 14 17H6C4.34315 17 3 15.6569 3 14V6Z"
        stroke="#425F80"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 7V18C21 19.6569 19.6569 21 18 21H7"
        stroke="#425F80"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12V8L12.1429 10L9 12Z"
        fill="#425F80"
        stroke="#425F80"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PdfSvg() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM15.2 10.8C14.7 10.3 14.1 10 12.8 10H9V19H10.6V15.7H12.8C14.1 15.7 14.6 15.5 15.2 15C15.8 14.5 16 13.8 16 12.9C16 12 15.8 11.4 15.2 10.8ZM13.9 14C13.6 14.3 13.3 14.5 12.7 14.5H10.6V11.3H12.6C13.2 11.3 13.6 11.5 13.9 11.8C14.2 12.1 14.3 12.4 14.3 12.9C14.3 13.4 14.2 13.7 13.9 14Z"
        fill="#425F80"
      />
    </svg>
  );
}
